import apiClient from './client'

import type { PaginatedResponse, Usuario, UsuarioInput } from '@/types/gia'

interface UsuarioFilters {
  page?: number
  centro?: number
  rol?: string
}

const usuariosApi = {
  list: async (filters: UsuarioFilters = {}): Promise<PaginatedResponse<Usuario>> => {
    const response = await apiClient.get<PaginatedResponse<Usuario>>('/usuarios/', {
      params: filters
    })

    return response.data
  },

  create: async (payload: UsuarioInput): Promise<Usuario> => {
    const response = await apiClient.post<Usuario>('/usuarios/', payload)

    return response.data
  },

  update: async (id: number, payload: Partial<UsuarioInput>): Promise<Usuario> => {
    const response = await apiClient.put<Usuario>(`/usuarios/${id}/`, payload)

    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/usuarios/${id}/`)
  },

  toggleActive: async (id: number): Promise<Usuario> => {
    const response = await apiClient.post<Usuario>(`/usuarios/${id}/toggle_active/`)

    return response.data
  }
}

export default usuariosApi
